import { Title } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/Title";
import type { IChart } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface IHeader extends IChart {}

const { carbon } = colorsPalettes;

const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 12px 12px 24px;
    border-bottom: 1px solid ${carbon[100]};
    align-items: center;
`;

export const Header: FC<IHeader> = (props) => {
    return (
        <Container>
            <FlexColumn gap={"8px"}>
                <Title />
            </FlexColumn>
        </Container>
    );
};
